import { Injectable } from '@angular/core';
import { TypeAdresseCompleteObligatoireService } from '../typeAdresseCompleteObligatoire/type-adresse-complete-obligatoire.service';

@Injectable({
  providedIn: 'root'
})
export class DiversService {

  constructor(public typeAdresseCompleteObligatoireService: TypeAdresseCompleteObligatoireService) {
  }
}
